import { api } from '@/lib/api';
import { DocumentResponse } from '@/types/api';

export class DocumentService {
  
  // Listar todos os documentos do usuário
  static async getAllDocuments(): Promise<DocumentResponse[]> {
    const response = await api.get<DocumentResponse[]>('/documents');
    return response.data;
  }

  // Upload de documento
  static async uploadDocument(file: File, description?: string): Promise<DocumentResponse> {
    const formData = new FormData();
    formData.append('file', file);
    
    if (description) {
      formData.append('description', description);
    }

    const response = await api.post<DocumentResponse>('/documents/upload-file', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  }

  // Buscar documento por ID
  static async getDocumentById(id: string): Promise<DocumentResponse> {
    const response = await api.get<DocumentResponse>(`/documents/${id}`);
    return response.data;
  }

  // Download de documento
  static async downloadDocument(id: string): Promise<Blob> {
    const response = await api.get(`/documents/${id}/download`, {
      responseType: 'blob',
    });
    
    return response.data;
  }

  // Deletar documento
  static async deleteDocument(id: string): Promise<void> {
    await api.delete(`/documents/${id}`);
  }

  // Função utilitária para fazer download com nome do arquivo
  static async downloadDocumentWithName(documentData: DocumentResponse): Promise<void> {
    try {
      const blob = await this.downloadDocument(documentData.id);
      
      // Criar URL temporária para o blob
      const url = window.URL.createObjectURL(blob);
      
      // Criar elemento de link temporário
      const link = document.createElement('a');
      link.href = url;
      link.download = documentData.originalName;
      
      // Adicionar ao DOM, clicar e remover
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Limpar URL temporária
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao fazer download:', error);
      throw error;
    }
  }
}